import { render, staticRenderFns } from "./ProductFilters.vue?vue&type=template&id=132ea864&scoped=true"
import script from "./ProductFilters.vue?vue&type=script&lang=js"
export * from "./ProductFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132ea864",
  null
  
)

export default component.exports